import { render } from "./NavBase.vue?vue&type=template&id=4ab6aa10&scoped=true"
import script from "./NavBase.vue?vue&type=script&lang=js"
export * from "./NavBase.vue?vue&type=script&lang=js"

import "./NavBase.vue?vue&type=style&index=0&id=4ab6aa10&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab6aa10"]])

export default __exports__